import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import gql from 'graphql-tag';

@Injectable({
  providedIn: 'root'
})
export class CompanyQueries {
  constructor() { }

  listCompanies(): DocumentNode {
    return gql`
      query companiesPaginated($where: CompanyWhereInput, $orderBy: CompanyOrderByInput, $limit: Int, $offset:Int) {
        companies(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
          totalCount
          items {
            id
            name
            avatarUrl
            lastLoginAt
            createdAt
            archived
          }
        }
      }
    `;
  }

  listAllMaintenancesTypes(): DocumentNode {
    return gql`
      query maintenanceTypesPaginated($limit: Int, $offset:Int) {
        maintenanceTypes(orderBy: name_asc, limit: $limit, offset: $offset) {
          totalCount
          items {
            id
            name
            archived
          }
        }
      }
    `;
  }

  getCompanyById(): DocumentNode {
    return  gql`
      query searchCompany($id: ID!) {
        company(id: $id) {
          fieldAccountId
          id
          name
          avatarUrl
          lastLoginAt
          archived
          preferences {
            featureDisableEditTaskStatus
            featureHideCancelTicketButton
            featureDisableCreateEquipment
            featureQuotationServiceOrderRequired
            featureDisableCreateEquipmentByApp
            featureAssignedEmployeeRequired
            featurePendenciesEnabled
            allowOpenMaintenanceForMaintenanceTypeIds
            featureAllowCompanyCreateRecurrence
            featureRecurrenceAssignedEmployeeRequired
            featureStorageControlEnabledByCMMS
          }
          address {
            countryCode
            zipCode
            state
            city
            neighborhood
            street
            number
            complement
            coords {
              latitude
              longitude
            }
          }
        }
      }
    `;
  }

  updateCompany(): DocumentNode {
    return gql`
      mutation updateCompany($id: ID!, $input: CompanyInput!) {
        updateCompany(id: $id, input: $input) {
          id
          name
          avatarUrl
          archived
        }
      }
    `;
  }

  archiveCompanyAndUnlinkServiceProvider(): DocumentNode {
    return  gql`
      mutation archiveCompanyAndUnlinkServiceProvider($companyId: ID!) {
        archiveCompanyAndUnlinkServiceProvider(companyId: $companyId) {
          id
        }
      }
    `;
  }
}
